global.BOXWIDTH = 200;
global.BOXHEIGHT = 141;
global.BOTTOMGAP = 50;
global.SIDEGAP = 100;
global.START = "Start Node";
global.ACTIVITY = "Activity Node";
global.END = "End Node";
global.OUTGOING = "1";
global.BIDIRECTIONAL = "3";
global.INCOMING = "5";
global.FALSEPARENT = "2";
global.FALSECHILD = "4";
global.UNSELECTED = 1;
global.LOW = 2;
global.MEDIUM = 3;
global.HIGH = 4;
global.CAREUNSELECTED = "";
global.PRIMARY = "Primary";
global.SECONDARY = "Secondary";
global.SOCIAL = "Community";
global.SHOWINFOBTNDEFAULT = 0;
global.SHOWINFOBTN = 0;
global.HIDEINFOBTN = 1;

(function(window) {
  "use strict";
  function defineDiagram() {
    var s = {};
    var thirdallnodes = [];
    var config = {
        boxwidth: 200,
        boxheight: 141,
        maxDepth: 100,
        levelSeparation: 60,
        siblingSeparation: 100,
        subtreeSeparation: 100,
        topXAdjustment: 0,
        topYAdjustment: 50
      },
      maxLevelHeight = [],
      maxLevelWidth = [],
      previousLevelTree = [],
      rootXOffset = 0,
      rootYOffset = 0,
      setlevelheight = function(node, level) {
        maxLevelHeight[level] = node.height;
      },
      setlevelwidth = function(node, level) {
        maxLevelWidth[level] = node.width;
      },
      setneighbors = function(node, level) {
        node.leftNeighbor = previousLevelTree[level];
        if (node.leftNeighbor) node.leftNeighbor.rightNeighbor = node;
        previousLevelTree[level] = node;
      },
      getleftmost = function(node, level, maxlevel) {
        if (level >= maxlevel) return node;
        if (node.numchildren() === 0) return null;
        var n = node.numchildren();
        for (var i = 0; i < n; i++) {
          var iChild = node.getchildat(i);
          var leftmostDescendant = getleftmost(iChild, level + 1, maxlevel);
          if (leftmostDescendant !== null) return leftmostDescendant;
        }
        return null;
      },
      getnodesize = function(node) {
        return node.width;
      },
      apportion = function(node, level) {
        var firstChild = node.getfirstchild(),
          firstChildLeftNeighbor = firstChild.leftNeighbor,
          j = 1;
        for (
          var k = config.maxDepth - level;
          firstChild != null && firstChildLeftNeighbor != null && j <= k;

        ) {
          var modifierSumRight = 0;
          var modifierSumLeft = 0;
          var rightAncestor = firstChild;
          var leftAncestor = firstChildLeftNeighbor;
          for (var l = 0; l < j; l++) {
            rightAncestor = rightAncestor.parentTree;
            leftAncestor = leftAncestor.parentTree;
            if (rightAncestor != null) {
              modifierSumRight += rightAncestor.modifier;
            }

            if (leftAncestor != null) {
              modifierSumLeft += leftAncestor.modifier;
            }
          }
          var totalGap =
            firstChildLeftNeighbor.prelim +
            modifierSumLeft +
            getnodesize(firstChildLeftNeighbor) +
            config.subtreeSeparation -
            (firstChild.prelim + modifierSumRight);
          if (totalGap > 0) {
            var subtreeAux = node;
            var numSubtrees = 0;
            for (
              ;
              subtreeAux != null && subtreeAux != leftAncestor;
              subtreeAux = subtreeAux.getleftsibling()
            ) {
              numSubtrees++;
            }
            if (subtreeAux != null) {
              var subtreeMoveAux = node;
              var singleGap = totalGap / numSubtrees;
              for (
                ;
                subtreeMoveAux != leftAncestor;
                subtreeMoveAux = subtreeMoveAux.getleftsibling()
              ) {
                subtreeMoveAux.prelim += totalGap;
                subtreeMoveAux.modifier += totalGap;
                totalGap -= singleGap;
              }
            }
          }
          j++;
          if (firstChild.numchildren() == 0) {
            firstChild = getleftmost(node, 0, j);
          } else {
            firstChild = firstChild.getfirstchild();
          }
          if (firstChild != null) {
            firstChildLeftNeighbor = firstChild.leftNeighbor;
          }
        }
      },
      firstwalk = function(node, level) {
        var leftSibling = null;
        node.x = 0;
        node.y = 0;
        node.prelim = 0;
        node.modifier = 0;
        node.leftNeighbor = null;
        node.rightNeighbor = null;
        setlevelheight(node, level);
        setlevelwidth(node, level);
        setneighbors(node, level);
        if (node.numchildren() === 0 || level == config.maxDepth) {
          leftSibling = node.getleftsibling();
          if (leftSibling !== null)
            node.prelim =
              leftSibling.prelim +
              getnodesize(leftSibling) +
              config.siblingSeparation;
          else node.prelim = 0;
        } else {
          var n = node.numchildren();
          for (var i = 0; i < n; i++) {
            firstwalk(node.getchildat(i), level + 1);
          }
          var midPoint = node.getchildrencenter();
          midPoint -= getnodesize(node) / 2;
          leftSibling = node.getleftsibling();
          if (leftSibling) {
            node.prelim =
              leftSibling.prelim +
              getnodesize(leftSibling) +
              config.siblingSeparation;
            node.modifier = node.prelim - midPoint;
            apportion(node, level);
          } else {
            node.prelim = midPoint;
          }
        }
      },
      /* eslint-disable-next-line */
      // drawnode = function(node) {
      //   console.log("drawnodes called x:" + node.x + ", y:" + node.y);
      // },
      positiontree = function(node) {
        maxLevelHeight = [];
        maxLevelWidth = [];
        previousLevelTree = [];
        firstwalk(node, 0);
        rootXOffset = config.topXAdjustment + node.x;
        rootYOffset = config.topYAdjustment + node.y;
        secondwalk(node, 0, 0, 0);
        rootXOffset = Math.abs(getminx(node)) + 80; //Align to left
        secondwalk(node, 0, 0, 0);
        thirdallnodes = getnodelist(node);
        thirdwalk(node, 0, 0, 0); //need to call this again to get x coordinates for rightside nodes
      },
      secondwalk = function(node, level, X, Y) {
        node.x = rootXOffset + node.prelim + X;
        node.y = rootYOffset + Y;
        var rightSibling = node.getrightsibling();
        if (node.numchildren())
          secondwalk(
            node.getfirstchild(),
            level + 1,
            X + node.modifier,
            Y + maxLevelHeight[level] + config.levelSeparation
          );
        if (rightSibling) secondwalk(rightSibling, level, X, Y);
      },
      thirdwalk = function(node, level, X, Y) {
        node.x = rootXOffset + node.prelim + X;
        node.y = rootYOffset + Y;
        var leftSibling = node.getleftsibling();
        var rightSibling = node.getrightsibling();
        let pnodes = thirdallnodes
          .filter(
            n =>
              n.id === node.parentid ||
              (n.level === node.level - 1 &&
                n.connections.length > 0 &&
                n.connections.filter(c => c.id === node.id).length > 0)
          )
          .sort(compare);
        let pn = pnodes.filter(n => n.id === node.parentid)[0];
        if (
          !node.leftNeighbor &&
          !node.rightNeighbor &&
          rightSibling === null &&
          leftSibling === null &&
          pnodes.length > 1
        ) {
          let m = getparentspan(node);
          let nx = m; //node.x + m;
          node.modifier = nx - pn.x;
          node.x = nx;
        }
        if (node.numchildren())
          thirdwalk(
            node.getfirstchild(),
            level + 1,
            X + node.modifier,
            Y + maxLevelHeight[level] + config.levelSeparation
          );
        if (rightSibling) thirdwalk(rightSibling, level, X, Y);
      },
      getparentspan = function(node) {
        let pnodesatlevel = thirdallnodes
          .filter(n => n.level === node.level - 1)
          .sort(compare);
        let leading = 0;
        let trailing = 0;
        let firstp = null;
        for (let i = 0; i < pnodesatlevel.length; i++) {
          if (
            !(
              pnodesatlevel[i].id === node.parentid ||
              (pnodesatlevel[i].connections.length > 0 &&
                pnodesatlevel[i].connections.filter(c => c.id === node.id)
                  .length > 0)
            )
          ) {
            leading++;
          } else {
            firstp = pnodesatlevel[i];
            break;
          }
        }
        for (let i = pnodesatlevel.length - 1; i > -1; i--) {
          if (
            !(
              pnodesatlevel[i].id === node.parentid ||
              (pnodesatlevel[i].connections.length > 0 &&
                pnodesatlevel[i].connections.filter(c => c.id === node.id)
                  .length > 0)
            )
          ) {
            trailing++;
          } else {
            break;
          }
        }
        let numnodes = pnodesatlevel.length - leading - trailing;
        let span1 = numnodes * parseInt(global.BOXWIDTH);
        let span2 = (numnodes - 1) * parseInt(global.SIDEGAP);
        let m =
          (span1 + span2) * 0.5 - parseInt(global.BOXWIDTH) * 0.5 + firstp.x;
        return m;
      },
      getminx = function(node) {
        var nodes = getnodelist(node);
        var min = 0;
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].x < min) min = nodes[i].x;
        }
        return min;
      },
      getnodelist = function(node) {
        var nodeList = [];
        nodeList.push(node);
        for (var i = 0; i < node.numchildren(); i++) {
          nodeList = nodeList.concat(getnodelist(node.getchildat(i)));
        }
        return nodeList;
      },
      getmaxlength = function(s, root) {
        let len = 0;
        var allnodes = getnodelist(root);
        allnodes.forEach(n => {
          if (n.x > len) {
            len = n.x;
          }
        });
        len += BOXWIDTH;
        return len;
      },
      getmaxlevel = function(s, root) {
        let level = 1;
        var allnodes = getnodelist(root);
        allnodes.forEach(n => {
          if (n.level > level) {
            level = n.level;
          }
        });

        return level;
      },
      compare = function(a, b) {
        if (a.x < b.x) return -1;
        if (a.x > b.x) return 1;
        return 0;
      };

    var Diagram = {};

    Diagram.init = function() {};

    Diagram.getWidestRightNodeBetween = function(lowerNode, upperLevel) {
      var n = lowerNode;
      var widest = 0;
      while (n && n.level >= upperLevel) {
        if (n.x + n.width > widest) widest = n.x + n.width;
        n = n.parentTree;
        while (n && n.rightNeighbor) {
          n = n.rightNeighbor;
        }
      }
      return widest;
    };

    Diagram.getWidestLeftNodeBetween = function(lowerNode, upperLevel) {
      var n = lowerNode;
      var widest = 9999;
      while (n && n.level >= upperLevel) {
        if (n.x < widest) widest = n.x;
        n = n.parentTree;
        while (n && n.leftNeighbor) {
          n = n.leftNeighbor;
        }
      }
      return widest;
    };

    Diagram.calcposition = function(snap, node) {
      s = snap;
      this.node = node;
      s.clear();

      positiontree(node);
      /* eslint-disable-next-line */
      var allnodes = getnodelist(node);
      var mincanvasheight = 620;
      let maxlen = getmaxlength(s, node) + 140;
      let maxlevel = getmaxlevel(s, node);
      let maxh = mincanvasheight;
      maxh =
        maxlevel > 2
          ? (maxlevel + 1.5) * (config.boxheight + config.levelSeparation)
          : mincanvasheight;

      // s.attr({
      //   width: maxlen,
      //   height: maxh,
      //   viewBox: "0 0 " + maxlen + " " + maxh
      // });

      return node;
    };

    return Diagram;
  }
  if (typeof Diagram === "undefined") {
    window.Diagram = defineDiagram();
  }
})(window);

export function Node() {
  this.id = this.generateid();
  this.parentid = 0;
  this.umbraconodeid = 0;
  this.name = "";
  this.type = "";
  this.x = 0;
  this.y = 0;
  this.prelim = 0;
  this.modifier = 0;
  this.width = BOXWIDTH;
  this.height = BOXHEIGHT;
  this.span = BOXWIDTH + SIDEGAP;
  this.level = 0;
  this.connections = [];
  this.children = [];
  this.leftNeighbor = null;
  this.rightNeighbor = null;
  this.parentTree = null;
  this.levelIndex = 0;
  this.nodeType = ACTIVITY;
  this.calculatorUrl = "";
  this.pathwayUrl = "";
  this.externalUrl = "";
  this.telephone = "";
  this.emailAddress = "";
  this.nodeFunction = "";
  this.shortDescription = "";
  this.longDescription = "";
  this.riskSeverity = 1;
  this.careSetting = "";
  this.showInfoBtn = SHOWINFOBTNDEFAULT;
  this.sortOrder = 0;
  this.parentLabel = "";
  this.line = 1;
}

Node.prototype.getlevel = function() {
  return this.level;
};

Node.prototype.numchildren = function() {
  return this.children.length;
};

Node.prototype.sortchildren = function() {
  this.children = this.children.sort((x, y) =>
    x.sortOrder > y.sortOrder ? 1 : -1
  );
  this.children[0].leftSibling = null;
  for (var i = 1; i < this.children.length - 1; i++) {
    this.children[i].leftSibling = this.children[i - 1];
    this.children[i].rightSibling = this.children[i + 1];
  }
  this.children[this.children.length - 1].rightSibling = null;
};

Node.prototype.getleftsibling = function() {
  return this.leftNeighbor && this.leftNeighbor.parentTree === this.parentTree
    ? this.leftNeighbor
    : null;
};

Node.prototype.getrightsibling = function() {
  return this.rightNeighbor && this.rightNeighbor.parentTree === this.parentTree
    ? this.rightNeighbor
    : null;
};

Node.prototype.getchildat = function(index) {
  return this.children[index];
};

Node.prototype.getchild = function(id) {
  var i;
  for (i = 0; i < this.children.length; i++) {
    if (this.children[i].id === id) {
      return this.children[i];
    }
  }
};

Node.prototype.getchildrencenter = function() {
  var firstChild = this.getfirstchild(),
    lastChild = this.getlastchild();
  return (
    firstChild.prelim +
    (lastChild.prelim - firstChild.prelim + lastChild.width) / 2
  );
};

Node.prototype.getfirstchild = function() {
  return this.getchildat(0);
};

Node.prototype.getlastchild = function() {
  return this.getchildat(this.numchildren() - 1);
};

Node.prototype.isLeftmostOnLevel = function(lev) {
  if (this.level === 0) return true;
  if (
    this.leftNeighbor &&
    (this.leftNeighbor.numchildren === 0 || this.level == lev)
  )
    return false;
  return this.parentTree.isLeftmostOnLevel(lev);
};

Node.prototype.isRightmostOnLevel = function(lev) {
  if (this.level === 0) return true;
  if (
    this.rightNeighbor &&
    (this.rightNeighbor.numchildren === 0 || this.level == lev)
  )
    return false;
  return this.parentTree.isRightmostOnLevel(lev);
};

Node.prototype.addchild = function(node) {
  if (node.id === 0) node.id = this.generateid();
  node.parentTree = this;
  node.parentid = this.id;
  node.sortOrder = this.children ? this.children.length : 0;
  this.children.push(node);
};

Node.prototype.addconnection = function(node, dir, label, line) {
  if (!label) label = "";
  if (!line) line = 1;
  if (!this.connections.find(x => x.id === node.id))
    this.connections.push({
      id: node.id,
      type: dir.toString(),
      label: label,
      line: line,
      xOffset: 0,
      yOffset: 0,
      overlapOffset: 0
    });
  else {
    this.connections.find(x => x.id === node.id).label = label;
  }
  if (!node.connections.find(x => x.id === this.id))
    node.connections.push({
      id: this.id,
      type: (6 - parseInt(dir)).toString(),
      label: "",
      line: line,
      xOffset: 0,
      yOffset: 0,
      overlapOffset: 0
    });
};

Node.prototype.getConnections = function(root) {
  return this.connections.map(function(c) {
    return {
      n: root.getdescendent(c.id),
      type: c.type,
      label: c.label,
      line: c.line,
      xOffset: c.xOffset,
      yOffset: c.yOffset
    };
  });
};

Node.prototype.getOffsetConnections = function(root, midPoint) {
  var self = this;
  let conns = this.connections.map(function(c) {
    return {
      n: root.getdescendent(c.id),
      type: c.type,
      label: c.label,
      line: c.line,
      xOffset: c.xOffset,
      yOffset: c.yOffset
    };
  });

  let leftSideConns = conns
    .filter(function(el) {
      return (
        el.type !== FALSEPARENT &&
        el.type !== FALSECHILD &&
        el.n &&
        el.n.level !== self.level &&
        (el.n.isLeftmostOnLevel(el.n.level) &&
          self.isLeftmostOnLevel(self.level) &&
          !(
            self.isRightmostOnLevel(self.level) &&
            el.n.isRightmostOnLevel(el.n.level)
          )) // &&
        // !(self.x < midPoint || el.n.x < midPoint)
      );
    })
    .sort((x, y) =>
      x.n.level < self.level && y.n.level < self.level
        ? x.n.level < y.n.level
          ? 1
          : -1
        : x.n.level > self.level && y.n.level > self.level
        ? x.n.level > y.n.level
          ? 1
          : -1
        : x.n.level > y.n.level
        ? 1
        : -1
    );

  let currX = self.x;
  let iX = 1;
  let above = true;
  let belowIndex = 0;

  leftSideConns.forEach((x, i) => {
    if (x.n.level > self.level && above) {
      above = false;
      iX = 1;
      currX = x.n.x;
    }

    if (x.n.x < currX) {
      currX = x.n.x;
      iX = 1;
    }

    self.connections.find(y => y.id === x.n.id).yOffset =
      x.n.level < self.level
        ? (BOXHEIGHT / (leftSideConns.length + 1)) * (i + 1)
        : (BOXHEIGHT / (leftSideConns.length + 1)) *
          (leftSideConns.length - belowIndex++);
    self.connections.find(y => y.id === x.n.id).xOffset = iX++ * 25;
  });

  currX = self.x;
  iX = 1;
  above = true;
  belowIndex = 0;

  let lIds = leftSideConns.map(z => z.n.id);

  let rightSideConns = conns
    .filter(function(el) {
      return (
        el.type !== FALSEPARENT &&
        el.type !== FALSECHILD &&
        el.n &&
        el.n.level !== self.level &&
        el.n.isRightmostOnLevel(el.n.level) &&
        !lIds.find(z => z == el.n.id)
      );
    })
    .sort((x, y) =>
      x.n.level < self.level && y.n.level < self.level
        ? x.n.level < y.n.level
          ? 1
          : -1
        : x.n.level > self.level && y.n.level > self.level
        ? x.n.level > y.n.level
          ? 1
          : -1
        : x.n.level > y.n.level
        ? 1
        : -1
    );

  rightSideConns.forEach((x, i) => {
    if (x.n.level > self.level && above) {
      above = false;
      iX = 1;
      currX = x.n.x;
    }

    if (x.n.x > currX) {
      currX = x.n.x;
      iX = 1;
    }

    self.connections.find(y => y.id === x.n.id).yOffset =
      x.n.level < self.level
        ? (BOXHEIGHT / (rightSideConns.length + 1)) * (i + 1)
        : (BOXHEIGHT / (rightSideConns.length + 1)) *
          (rightSideConns.length - belowIndex++);
    self.connections.find(y => y.id === x.n.id).xOffset = iX++ * 25;
  });

  return this.connections.map(function(c) {
    return {
      id: c.id,
      n: root.getdescendent(c.id),
      type: c.type,
      label: c.label,
      line: c.line,
      xOffset: c.xOffset,
      yOffset: c.yOffset,
      overlapOffset: c.overlapOffset
    };
  });
};

Node.prototype.getdescendent = function(id) {
  var children = this.children;
  var found;
  if (this.id === id) {
    return this;
  } else if (this.getchild(id)) {
    return this.getchild(id);
  } else {
    for (var i = 0; i < children.length; i++) {
      found = children[i].getdescendent(id);
      if (found) {
        return found;
      }
    }
  }
};

Node.prototype.generateid = function() {
  var d = new Date();
  var n = d.valueOf();
  return n;
};

Node.prototype.getchildren = function(pid, root) {
  var children = root.children;
  if (this.id === pid) {
    return this.children;
  } else {
    for (var i = 0; i < children.length; i++) {
      if (children[i].parentid === pid) {
        return children[i].children;
      } else {
        return children[i].getchildren(pid, children[i]);
      }
    }
  }
};

Node.prototype.getbyid = function(id, node) {
  var children = this.children;
  var found;
  if (node.id === id) {
    return this;
  } else if (this.getchild(id)) {
    return this.getchild(id);
  } else {
    for (var i = 0; i < children.length; i++) {
      found = children[i].getbyid(id, children[i]);
      if (found) {
        return found;
      }
    }
  }
};

Node.prototype.getAllPossibleConnections = function(n) {
  var nodeList = [];
  let id = n.id;
  let connections = n.connections.map(x => x.id);
  if (
    this.id !== id &&
    this.parentid !== id &&
    connections.indexOf(this.id) === -1
  ) {
    if (n.isLeftmostOnLevel(n.level) && this.isLeftmostOnLevel(this.level)) {
      nodeList.push(this);
    } else if (
      n.isRightmostOnLevel(n.level) &&
      this.isRightmostOnLevel(this.level)
    ) {
      nodeList.push(this);
    } else if (n.leftNeighbor === this) {
      nodeList.push(this);
    } else if (n.rightNeighbor === this) {
      nodeList.push(this);
    }
  }

  for (var i = 0; i < this.numchildren(); i++) {
    nodeList = nodeList.concat(this.getchildat(i).getAllPossibleConnections(n));
  }
  return nodeList;
};

Node.prototype.toObjectString = function(undoType) {
  let obj = {
    id: this.id,
    parentid: this.parentid,
    name: this.name,
    type: this.type,
    level: this.level,
    connections: this.connections,
    children: this.children.map(function(c) {
      return c.toObjectString();
    }),
    leftNeighbor: this.leftNeighbor ? this.leftNeighbor.id : 0,
    rightNeighbor: this.rightNeigbor ? this.rightNeighbor.id : 0,
    levelIndex: this.levelIndex,
    nodeType: this.nodeType,
    pathwayUrl: this.pathwayUrl,
    emailAddress: this.emailAddress,
    telephone: this.telephone,
    nodeFunction: this.nodeFunction,
    shortDescription: this.shortDescription,
    longDescription: this.longDescription,
    riskSeverity: this.riskSeverity,
    careSetting: this.careSetting,
    undoType: undoType,
    x: this.x,
    y: this.y,
    width: this.width,
    height: this.height,
    parentLabel: this.parentLabel,
    line: this.line
  };
  return JSON.stringify(obj);
};

Node.prototype.StringtoObject = function(_json) {
  let newnode = new Node();
  let n = JSON.parse(_json);
  newnode.id = n.id;

  return n;
};
